import React from "react";
import styled from 'styled-components';
import environmentVariables from "../../config/environmentVariables";
const SmartIcon1 = `${environmentVariables?.cdnUrl}ListedNft.png`;

const Root = styled.div`
background-color: #151a1c;
 padding:${(p) => p.theme.spacing.md};
 background-position:center;
 background-repeat:no-repeat;
 background-size:100% 100%;
 margin-top:${(p) => p.theme.spacing.sm};
 border-radius:${(p) => p.theme.spacing.sm};
`;

const Title = styled.div`
color: #707070;
margin-bottom:10px;
font-size:22px;
@media(min-width:1600px){
   
}
`;
const Count = styled.div`
 display:flex;
 align-items:center;
 font-size:${(p) => p.theme.font.size.xl};
 font-weight:${(p) => p.theme.font.weight.bolder};
 margin-bottom:${(p) => p.theme.spacing.xs};
 @media(max-width:${(p) => p.theme.screen.xxs}){
     font-size:${(p) => p.theme.font.size.lg};
 }

`;

const Amount = styled.div`
color:${(p) => p.theme.colors.lightskytextcolor};
font-size:${(p) => p.theme.font.size.xs};
@media(min-width:1600px){
    font-size:${(p) => p.theme.font.size.md};
}
`;

const Icon = styled.img`
width:30px;
`;
const IconWrapper = styled.div`
width:50px;
height:50px;
border-radius:50%;
background-color:#1c2122;
display:flex;
align-items:center;
justify-content:center;
margin-right:10px;
`;
const MLDSection = ({showdata, setShowData}) => {
    return (
        <Root>
            {/* <Title>MLD total Mining Pool (MLD)</Title> */}
            <Title> Listed NFT</Title> 
            <Count>
                <IconWrapper>
                    <Icon src={SmartIcon1} />
                </IconWrapper> {showdata?.totalNFTs}
            </Count>
            {/* <Amount>$3,976,946</Amount> */}
        </Root>
    );
};

export default MLDSection;